exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._15YKx{font-size:14px}._2KVGP{width:100%;height:42px}._1yPd5{margin:-8px 0 0}", ""]);

// exports
exports.locals = {
	"title": "_15YKx",
	"input": "_2KVGP input",
	"slider": "_1yPd5"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/UI/NumberInputWithSlider/NumberInputWithSlider.css
// module id = 3193
// module chunks = 21